module.exports = __webpack_public_path__ + "static/media/NancyCushing-Jones.b085ec96.jpeg";